import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TTicketManagementActions } from './ticket-management.actions';
import { TTicketManagementActionType, TTicketManagementState } from './ticket-management.models';

export const intialState: TTicketManagementState = {
  employeeTicketSummary: null,
  ticketSummaryAnalytics: null,
  employeeTickets: null,
  employeeTicketDetails: null,
  machineTicketHistory: {
    machineIssueTickets: null,
    maintenanceTickets: null,
  },
  breakdownReasonsAndSolution: null,
  employeeRole: {
    isSupervisor: true,
    isMechanic: false,
  },
  factoryShiftDetails: null,
  maintenanceTickets: null,
  sparePartRequestsBySource: null,
  sparepartRequestReasons: null,
  employeeTicketsPagination: {
    pageNo: 1,
    pageSize: LIST_ITEMS_PER_PAGE_LIST[0],
  },
  maintenanceTicketsPagination: {
    pageNo: 1,
    pageSize: LIST_ITEMS_PER_PAGE_LIST[0],
  },
};

export function ticketManagementReducer(state = intialState, action: TTicketManagementActions): TTicketManagementState {
  switch (action.type) {
    case TTicketManagementActionType.ResetEmployeeTickets:
      return {
        ...state,
        employeeTickets: null,
      };
    case TTicketManagementActionType.GetAllEmployeeTicketsSuccess:
      return {
        ...state,
        employeeTickets: {
          res: action.res,
          fetchReason: action.fetchReason,
        },
      };
    case TTicketManagementActionType.GetAllEmployeeTickets:
      return {
        ...state,
        employeeTickets: null,
      };
    case TTicketManagementActionType.GetEmployeeTicketDetailsSuccess:
      return {
        ...state,
        employeeTicketDetails: action.res,
      };
    case TTicketManagementActionType.GetEmployeeTicketDetails:
      return {
        ...state,
        employeeTicketDetails: null,
      };
    case TTicketManagementActionType.GetMachineTicketHistorySuccess:
      return {
        ...state,
        machineTicketHistory: {
          ...state.machineTicketHistory,
          machineIssueTickets: action.res,
        },
      };
    case TTicketManagementActionType.GetMachineTicketHistory:
      return {
        ...state,
        machineTicketHistory: {
          ...state.machineTicketHistory,
          machineIssueTickets: null,
        },
      };
    case TTicketManagementActionType.GetMachineMaintenanceHistorySuccess:
      return {
        ...state,
        machineTicketHistory: {
          ...state.machineTicketHistory,
          maintenanceTickets: action.res,
        },
      };
    case TTicketManagementActionType.GetMachineMaintenanceHistory:
      return {
        ...state,
        machineTicketHistory: {
          ...state.machineTicketHistory,
          maintenanceTickets: null,
        },
      };
    case TTicketManagementActionType.GetEmployeeTicketSummary:
      return {
        ...state,
        employeeTicketSummary: null,
      };
    case TTicketManagementActionType.GetEmployeeTicketSummarySuccess:
      return {
        ...state,
        employeeTicketSummary: action.res,
      };
    case TTicketManagementActionType.GetTicketSummaryAnalytics:
      return {
        ...state,
        ticketSummaryAnalytics: null,
      };
    case TTicketManagementActionType.GetTicketSummaryAnalyticsSuccess:
      return {
        ...state,
        ticketSummaryAnalytics: action.res,
      };
    case TTicketManagementActionType.GetBreakdownReasonAndSolutions:
    case TTicketManagementActionType.GetBreakdownReasonAndSolutionsFailure:
      return {
        ...state,
        breakdownReasonsAndSolution: null,
      };
    case TTicketManagementActionType.GetBreakdownReasonAndSolutionsSuccess:
      return {
        ...state,
        breakdownReasonsAndSolution: action.res,
      };
    case TTicketManagementActionType.GetFactoryShiftRevisionDetailsSuccess:
      return {
        ...state,
        factoryShiftDetails: action.res,
      };
    case TTicketManagementActionType.GetAllMaintenanceTicketsSuccess:
      return {
        ...state,
        maintenanceTickets: {
          res: action.res,
          fetchReason: action.fetchReason,
        },
      };
    case TTicketManagementActionType.GetSparepartRequestBySourceSuccess:
      return {
        ...state,
        sparePartRequestsBySource: action.res,
      };
    case TTicketManagementActionType.ResetSparepartRequestDetails: {
      return {
        ...state,
        sparePartRequestsBySource: null,
      };
    }
    case TTicketManagementActionType.GetSparepartRequestReasons:
      return {
        ...state,
        sparepartRequestReasons: null,
      };
    case TTicketManagementActionType.GetSparepartRequestReasonsSuccess:
      return {
        ...state,
        sparepartRequestReasons: action.res,
      };
    case TTicketManagementActionType.SetEmployeeTicketsPagination:
      return {
        ...state,
        employeeTicketsPagination: action.userPaginationOption,
      };
    case TTicketManagementActionType.SetMaintenanceTicketsPagination:
      return {
        ...state,
        maintenanceTicketsPagination: action.userPaginationOption,
      };
    default:
      return state;
  }
}
